import { CommonAdobeAnalyticsAdapter, COMMON_TAGGING_PROPERTIES } from 'saga-modules';

function configure(productAdapter, productTaggingProperties, isQnB) {
    const taggingProperties = { ...productTaggingProperties, ...COMMON_TAGGING_PROPERTIES };
    if (!window.SAGA) {
        window.SAGA = {
            adobe: {
                tagging: {
                    vertical: 'insurance',
                }
            }
        };
    }

    CommonAdobeAnalyticsAdapter.init(taggingProperties, window.SAGA.adobe.tagging, isQnB);
    productAdapter.init(taggingProperties, window.SAGA.adobe.tagging);
}

export default {
    configure,
};
